<template>
  <div>
    <b-modal
        :title="$t('Send invite request')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        no-close-on-backdrop>
      <ValidationObserver ref="form" tag="form" @submit.prevent="save()">
        <b-form-group>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-select v-model="formData.id" class="input-trans calendar">
              <option v-for="(s, i) in schedules" :key="i" :value="s.ScheduleID">
                {{ s.Name }}
              </option>
            </b-select>
            <div class="validate-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-input-group class="input-group-trans">
              <b-form-input v-model="formData.transId" :placeholder="$t('TranS ID / Mobile / Email')"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-id.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div class="validate-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t("Send request")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Sending request"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "SendInviteRequestModal",
  data() {
    return {
      show: false,
      loading: false,
      schedules: [],
      formData: {
        id: null,
        transId: ""
      }
    }
  },
  methods: {
    async open() {
      if (this.loading)
        return;

      this.loading = true;
      const response = await meetingService.initAddInviteRequest();
      this.loading = false;

      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.schedules = JSON.parse(response.substr(3));
      if (this.schedules.length > 0)
        this.formData.id = this.schedules[0].ScheduleID;

      this.formData.transId = "";
      this.show = true;
    },
    async save() {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading == true)
        return;

      this.loading = true;
      const response = await meetingService.sendInviteRequest(this.formData);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>